// utils/android.js
export const parseAndroidToken = (raw) => {
 if (!raw) return { kind: 'none' };

 const normalize = (obj) => {
   if (obj.token_type?.toLowerCase() === 'jwt') {
     return {
       kind: 'jwt',
       access: obj.access_token || obj.token,
       refresh: obj.refresh_token,
     };
   }
   // legacy / django session formats
   const access = obj.access_token || obj.token || obj;
   return { kind: 'legacy', access };
 };

 if (typeof raw === 'object') return normalize(raw);

 try {
   return normalize(JSON.parse(raw));
 } catch {
   // plain string like "Token abc123"
   return { kind: 'legacy', access: raw };
 }
};

export const getAndroidBasicHeaders = () => {
 if (typeof Android === 'undefined' || !Android.getBasicPayloadForAdvertiser)
   return {};
 try {
   const payload = JSON.parse(Android.getBasicPayloadForAdvertiser());
   const {
     'Accept-Language': lang,
     'Day-Count': day,
     'x-sdk-version': sdk,
     'x-app-version': app,
     app_type,
   } = payload;
   return {
     'Accept-Language': lang,
     'Day-Count': day,
     'x-sdk-version': sdk,
     'x-app-version': app,
     app_type,
   };
 } catch {
   return {};
 }
};
